// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__kui4n","title":"HeroContent_title__w2Wab","description":"HeroContent_description__HYrF7","control":"HeroContent_control__eoYyd"};